import {
  IssueReportedType,
  JobRecurranceType,
} from '../../constants/job-post/job-post.enums';
import { Job, Payer } from './job.model';

export class JobPostRequest {
  id: string;
  title: string;
  description: string;
  tenantId: string | null;
  propertyId: string;
  primaryJobTypeId: string;
  secondaryJobTypeId: string;
  maintenanceType: number;
  notifyOwner: boolean;
  urgencyType: number;
  urgencyDueDate: string;
  budgetType: number;
  BudgetAmount: number;
  BudgetMaxAmount: number;
  BudgetMinAmount: number;
  propertyAccessOption: number;
  propertyKeyCollectType: number;
  initialPayment: number;
  payerId: string | null;
  payerType: number;
  tradeeSelectionMode: number;
  targetTradeeOption: number;
  selectedTradees: string[];
  accessContact: string;
  drafteJob: boolean;
  attachments: {
    id: string;
    name: string;
    comment: string;
  }[];
  jobNote: {
    text: string;
    isPrivate: boolean;
    attachments: {
      id: string;
      name: string;
    }[];
  };
  jobRecurrence: {
    type: JobRecurranceType;
    start: string;
    end: string;
    customType?: number;
    daysToNotify: number;
    firstRecurrenceDueDate: string;
    noOfRecurrences: number;
    isUnlimited: boolean;
  };
  issueReportedType: IssueReportedType;
  saveAsDraft: boolean;
  payer: Payer;
  notifyTrade: boolean;
  reasonNotToNotifyTrade: string;
  specialNoteToTrade: string;
  customKeyCollectionValue: string;
  jobWarningNotes: string;
  assets: Array<{ id: string, isSharedWithTrade: boolean }>;
  cloneSourceJobId: string;
  isCloneWithJobNotes: boolean;
  ownerThreshold: number;
  doNotNotifyTrade:boolean;
  isFromAiJobPost:boolean;
  isFromAssetRecommendations: boolean;
  assetRecommendationId:string;
  constructor(job: Job, isDraftJob: boolean = false) {
    this.id = job.id;
    this.title = job.title;
    this.description = job.description;
    this.tenantId = job.tenant?.id;
    this.propertyId = job.property.id;
    this.primaryJobTypeId = job.primaryJobType.id;
    this.secondaryJobTypeId = job.secondaryJobType.id;
    this.maintenanceType = job.maintenanceType;
    this.notifyOwner = false;
    this.urgencyType = +job.priority.type;
    this.urgencyDueDate = job.priority.dueDate
      ?.toString()
      .toLocaleLowerCase()
      .endsWith('z')
      ? job.priority.dueDate.toString()
      : job.priority.dueDate?.toDateString();
    this.budgetType = job.budget.option;
    this.BudgetAmount = job.budget.amount;
    this.BudgetMinAmount = job.budget.amount;
    this.BudgetMaxAmount = job.budget.maxAmount;
    // this.initialPayment = 0;
    // this.payerId = job.payer.id;
    this.attachments = job.attachments.map((attachment) => ({
      id: attachment.blobName?.substring(
        0,
        attachment.blobName.lastIndexOf('.')
      ), //getId(),
      name: attachment.name,
      comment: attachment.comment,
    }));
    this.jobNote = {
      text: job.jobNote.text,
      isPrivate: job.jobNote.isPrivate,
      attachments: job.jobNote.attachmentData.map((attachment) => ({
        id: attachment.blobName?.substring(
          0,
          attachment.blobName.lastIndexOf('.')
        ), //getId(),
        name: attachment.name,
        blobUrl: attachment.blobUrl,

      })),
    };

    this.jobRecurrence = {
      type: job.recurrence?.type,
      start: job.recurrence?.start?.toString().toLocaleLowerCase().endsWith('z')
        ? job.recurrence.start.toString()
        : job.recurrence?.start?.toDateString(),
      end: job.recurrence?.end?.toString().toLocaleLowerCase().endsWith('z')
        ? job.recurrence.end.toString()
        : job.recurrence?.end?.toDateString(),
      customType: job.recurrence?.customType,
      daysToNotify: job.recurrence?.daysToNotify,
      firstRecurrenceDueDate: job.recurrence?.firstRecurrenceDueDate?.toDateString(),
      noOfRecurrences: job.recurrence?.noOfRecurrences,
      isUnlimited: job.recurrence?.isUnlimited
    };
    this.issueReportedType = job.issueReportedType;
    // this.saveAsDraft = job.assignTrades.trades.length == 0 || isDraftJob;
    this.saveAsDraft = isDraftJob;
    this.propertyKeyCollectType = job.keyCollectionType;
    this.payer = job.payer;
    this.accessContact = job.accessContact;
    this.notifyTrade = job.notifyTrade;
    this.reasonNotToNotifyTrade = job.reasonNotToNotifyTrade;
    this.specialNoteToTrade = job.specialNoteToTrade;
    this.customKeyCollectionValue = job.customKeyCollectionValue;
    this.jobWarningNotes = job.jobWarningNotes;
    this.assets = job.assets.map((asset) => ({ id: asset.id, isSharedWithTrade: asset.isSharedWithTrade }));
    this.cloneSourceJobId = job.id ?? null;
    this.isCloneWithJobNotes = job.isCloneWithJobNotes;
    this.ownerThreshold = job.ownerThreshold;
    this.doNotNotifyTrade=job.doNotNotifyTrade;
    this.isFromAiJobPost = job.isFromAiJobPost;
    this.isFromAssetRecommendations = job.isFromAssetRecommendations;
    this.assetRecommendationId = job.assetRecommendationId;
  }
}
